module.exports = __webpack_public_path__ + "static/media/diningVG.a02c1583.jpg";